import React from 'react'
import i18n from 'Pods/Shared/I18nHome'
import EndToEndServiceIcon from '../Icons/EndToEndService'
import Quality from '../Icons/Quality'
import FixedPricing from '../Icons/FixedPricing'
import ScalableProduction from '../Icons/ScalableProduction'
import DirectCollaboration from '../Icons/DirectCollaboration'
import FlexibleIterations from '../Icons/FlexibleIterations'
import LowPoly from '../../Shared/Icons/LowPoly'

export const getModerlySteps = (locale = 'en') => [
  {
    stepNumber: '01',
    position: 'first',
    stepTitle: i18n.t('customSolutions.modelry.steps.upload.title', {
      ns: 'new-home',
      lng: locale,
    }),
    stepDescription: i18n.t(
      'customSolutions.modelry.steps.upload.description',
      { lng: locale, ns: 'new-home' }
    ),
  },
  {
    highlightStep: true,
    stepNumber: '02',
    position: 'middle',
    stepTitle: i18n.t('customSolutions.modelry.steps.creation.title', {
      lng: locale,
      ns: 'new-home',
    }),
    stepDescription: i18n.t(
      'customSolutions.modelry.steps.creation.description',
      { lng: locale, ns: 'new-home' }
    ),
  },
  {
    stepNumber: '03',
    position: 'last',
    stepTitle: i18n.t('customSolutions.modelry.steps.approve.title', {
      lng: locale,
      ns: 'new-home',
    }),
    stepDescription: i18n.t(
      'customSolutions.modelry.steps.approve.description',
      { lng: locale, ns: 'new-home' }
    ),
  },
]

export const getModerlyFeatures = (locale = 'en') => [
  {
    title: i18n.t('customSolutions.modelry.features.endToEnd.title', {
      lng: locale,
      ns: 'new-home',
    }),
    description: i18n.t(
      'customSolutions.modelry.features.endToEnd.description',
      { lng: locale, ns: 'new-home' }
    ),
    icon: EndToEndServiceIcon,
  },
  {
    title: i18n.t('customSolutions.modelry.features.quality.title', {
      lng: locale,
      ns: 'new-home',
    }),
    description: i18n.t(
      'customSolutions.modelry.features.quality.description',
      { lng: locale, ns: 'new-home' }
    ),
    icon: Quality,
  },
  {
    title: i18n.t('customSolutions.modelry.features.pricing.title', {
      lng: locale,
      ns: 'new-home',
    }),
    description: i18n.t(
      'customSolutions.modelry.features.pricing.description',
      { lng: locale, ns: 'new-home' }
    ),
    icon: FixedPricing,
  },
  {
    title: i18n.t('customSolutions.modelry.features.scalable.title', {
      lng: locale,
      ns: 'new-home',
    }),
    description: i18n.t(
      'customSolutions.modelry.features.scalable.description',
      { lng: locale, ns: 'new-home' }
    ),
    icon: ScalableProduction,
  },
]

export const getThreeDJobsSteps = (locale = 'en') => [
  {
    stepNumber: '01',
    position: 'first',
    stepTitle: i18n.t('customSolutions.threeDJobs.steps.listing.title', {
      lng: locale,
      ns: 'new-home',
    }),
    highlightStep: true,
    stepDescription: i18n.t(
      'customSolutions.threeDJobs.steps.listing.description',
      { lng: locale, ns: 'new-home' }
    ),
  },
  {
    stepNumber: '02',
    position: 'middle',
    stepTitle: i18n.t('customSolutions.threeDJobs.steps.designer.title', {
      lng: locale,
      ns: 'new-home',
    }),
    stepDescription: i18n.t(
      'customSolutions.threeDJobs.steps.designer.description',
      { lng: locale, ns: 'new-home' }
    ),
  },
  {
    stepNumber: '03',
    position: 'last',
    stepTitle: i18n.t('customSolutions.threeDJobs.steps.model.title', {
      lng: locale,
      ns: 'new-home',
    }),
    stepDescription: i18n.t(
      'customSolutions.threeDJobs.steps.model.description',
      { lng: locale, ns: 'new-home' }
    ),
  },
]

export const getThreeDJobsFeatures = (locale = 'en') => [
  {
    title: i18n.t('customSolutions.threeDJobs.features.collaboration.title', {
      lng: locale,
      ns: 'new-home',
    }),
    description: i18n.t(
      'customSolutions.threeDJobs.features.collaboration.description',
      { lng: locale, ns: 'new-home' }
    ),
    icon: DirectCollaboration,
  },
  {
    title: i18n.t('customSolutions.threeDJobs.features.iterations.title', {
      lng: locale,
      ns: 'new-home',
    }),
    description: i18n.t(
      'customSolutions.threeDJobs.features.iterations.description',
      { lng: locale, ns: 'new-home' }
    ),
    icon: FlexibleIterations,
  },
  {
    title: i18n.t('customSolutions.threeDJobs.features.smaller.title', {
      lng: locale,
      ns: 'new-home',
    }),
    description: i18n.t(
      'customSolutions.threeDJobs.features.smaller.description',
      { lng: locale, ns: 'new-home' }
    ),
    icon: () => <LowPoly width="16" height="24" className="text-light-green" />,
  },
]
